import { Routes, Route, Navigate } from "react-router-dom";

import HomePage from "../../pages/HomePage/HomePage";
import ErrorPage from "../../pages/ErrorPage/ErrorPage";
import AuthPage from "../../pages/AuthPage/AuthPage";
import ItemFormPage from "../../pages/ItemFormPage/ItemFormPage";
import AdminPage from "../../pages/AdminPage/AdminPage";
import HiddenItemsPage from "../../pages/HiddenItemsPage/HiddenItemsPage";
import AboutArchivePage from "../../pages/AboutPages/AboutArchivePage";

export default function Main({ user, setUser }) {
  return (
    // grow fills the leftover height of App's min-h-screen flex column so
    // short pages still push the footer to the bottom
    <main className="mx-auto w-full grow">
      <Routes>
        <Route path="/" element={<HomePage user={user} />} />

        {/* Detail routes open as a modal over the homepage mosaic */}
        <Route
          path="/stamps/:catalogue_id"
          element={<HomePage user={user} />}
        />
        <Route
          path="/covers/:catalogue_id"
          element={<HomePage user={user} />}
        />
        <Route
          path="/articles/:catalogue_id"
          element={<HomePage user={user} />}
        />

        {/* Admin */}
        <Route path="/items/new" element={<ItemFormPage user={user} />} />
        <Route
          path="/items/:catalogue_id/edit"
          element={<ItemFormPage user={user} />}
        />
        <Route path="/admin" element={<AdminPage user={user} />} />
        <Route path="/hidden" element={<HiddenItemsPage user={user} />} />

        {/* Static pages; /team merged into /about but old links may exist */}
        <Route path="/about" element={<AboutArchivePage />} />
        <Route path="/team" element={<Navigate to="/about" replace />} />

        <Route
          path="/login"
          element={
            user ? <Navigate to="/" replace /> : <AuthPage setUser={setUser} />
          }
        />
        <Route path="/*" element={<ErrorPage />} />
      </Routes>
    </main>
  );
}
